import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import { TimesheetDeadlineSettings } from '@/components/TimesheetDeadlineSettings';
import { TabAccessAlerts } from './TabAccessAlerts';
import type { SettingsFormState } from '../hooks/useSettingsFormState';
import type { TimesheetDeadlineSettings as DeadlineSettingsType } from '@/types/timesheetSettings';

interface SubmissionsDeadlinesTabProps {
  form: SettingsFormState;
  deadlineSettings: DeadlineSettingsType;
  canEditDeadlines: boolean;
  onNavigate?: (path: string) => void;
}

export const SubmissionsDeadlinesTab: React.FC<SubmissionsDeadlinesTabProps> = ({
  form,
  deadlineSettings,
  canEditDeadlines,
  onNavigate,
}) => {
  const { tabsWithChanges, handleDeadlineChange } = form;

  return (
    <TabsContent value="submissions-deadlines" className="space-y-6">
      <TabAccessAlerts
        canEdit={canEditDeadlines}
        hasChanges={tabsWithChanges.has('submissions-deadlines')}
        viewOnlyText="You have view-only access to Submissions & Deadlines. Contact your administrator to request edit access."
        unsavedText={'You have unsaved changes. Click "Save Settings" at the bottom to apply your changes.'}
      />

      <TimesheetDeadlineSettings
        settings={deadlineSettings}
        onChange={handleDeadlineChange}
        onNavigateToNotifications={() => onNavigate?.('/settings/notifications')}
      />
    </TabsContent>
  );
};
